import type { ReactNode } from 'react';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

export const I18N_TYPE = 'i18n' as const;
export const NODE_TYPE = 'node' as const;

export type I18nDisplayable = {
	type: typeof I18N_TYPE;
	content: MessageDescriptor;
};

export type NodeDisplayable = {
	type: typeof NODE_TYPE;
	content: ReactNode;
};

export type Displayable = I18nDisplayable | NodeDisplayable;
